import type { ReactNode } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import Footer from '@/components/feature/Footer';

interface PageLayoutProps {
  children: ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <SiteHeader />

      {/* Main */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
}